var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399.999 733.331C391.159 733.331 382.68 729.819 376.429 723.568C370.178 717.316 366.666 708.838 366.666 699.997V299.997C366.666 291.157 370.178 282.678 376.429 276.427C382.68 270.176 391.159 266.664 399.999 266.664C408.84 266.664 417.318 270.176 423.57 276.427C429.821 282.678 433.333 291.157 433.333 299.997V699.997C433.333 708.838 429.821 717.316 423.57 723.568C417.318 729.819 408.84 733.331 399.999 733.331Z",
    fill: "#11A5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.999 333.331C473.637 333.331 533.333 273.635 533.333 199.997C533.333 126.359 473.637 66.6641 399.999 66.6641C326.361 66.6641 266.666 126.359 266.666 199.997C266.666 273.635 326.361 333.331 399.999 333.331Z",
    fill: "#11A5EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c6f031c6270e0d158db70153eadbfa67.svg";
export { ForwardRef as ReactComponent };